import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import PropTypes from "prop-types";

import { fetchCosts } from "../../features/cost/costActions";
import { ApplicationState } from "../../redux/initialState";
import { Cost } from "../../features/cost/costTypes";
import { SelectedCost } from "../../features/costFilter/selectedCostTypes";
import { updateCostFilter } from "../../features/costFilter/selectedCostActions";

import { Dropdown, DropdownOptions } from "@tal-gel/components-v2";

interface PropsFromState {
  loading: boolean;
  data: Cost[];
  errors?: string;
}

interface propsFromDispatch {
  fetchCosts: () => any;
  updateCostFilter: (SelectedCost: any) => any;
}

type AllProps = PropsFromState & propsFromDispatch;

const CostSelect: React.FC<AllProps> = ({ data, fetchCosts, updateCostFilter }) => {
  //needed to remember values when open / close mobile modal
  const [selectedOptions, setSelectedOptions] = useState<DropdownOptions>([]);

  useEffect(() => {
    if (!data.length) {
      fetchCosts();
    }
  }, [data.length, fetchCosts]);

  // Add a Select All option
  const selectAllOption = { value: "__select_all__", label: "All Cost" };
  const options: DropdownOptions = [selectAllOption, ...data.map(item => ({ value: item.id, label: item.externalName }))];

  const UpdateFilter = (selected: DropdownOptions = []) => {
    const isSelectAll = selected.some(option => option.value === "__select_all__");
    const wasSelectAll = (selectedOptions ?? []).some(option => option.value === "__select_all__");
    let newSelectedOptions: DropdownOptions;
    let values: string[];

    if (isSelectAll) {
      // If Select All is selected, include Select All and all other options
      newSelectedOptions = options;
      values = options.filter(option => option.value !== "__select_all__").map(option => String(option.value));
    } else if (wasSelectAll) {
      // If Select All was previously selected and now is not, clear all selections
      newSelectedOptions = [];
      values = [];
    } else {
      // Normal selection
      newSelectedOptions = selected.filter(option => option.value !== "__select_all__");
      values = newSelectedOptions.map(option => String(option.value));
    }

    setSelectedOptions(newSelectedOptions);
    const selectedCost: SelectedCost = {
      data: values,
    };
    updateCostFilter(selectedCost);
  };

  return (
    <Dropdown
      errorMessage=""
      id="dropdown_id"
      label="costDropdown"
      multiple
      onSelect={UpdateFilter}
      options={options}
      value={selectedOptions}
      placeholder="Select"
    />
  );
};

const mapStateToProps = ({ cost }: ApplicationState) => ({
  loading: cost.loading,
  errors: cost.errors,
  data: cost.data,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    fetchCosts: () => {
      dispatch(fetchCosts());
    },
    updateCostFilter: (selectedCost: SelectedCost) => {
      dispatch(updateCostFilter(selectedCost));
    },
  };
};

CostSelect.propTypes = {
  loading: PropTypes.any,
  data: PropTypes.any.isRequired,
  errors: PropTypes.string,
  fetchCosts: PropTypes.func.isRequired,
  updateCostFilter: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CostSelect);
